import React, {useState} from 'react';

interface CodePromptProps {
    title?: string;
    placeholder?: string;
    buttonText?: string;
    loadingText?: string;
    emptyCodeError?: string;
    onSubmit: (code: string) => Promise<void> | void;
    isLoading?: boolean;
    error?: string | null;
    containerClassName?: string;
    titleClassName?: string;
    inputClassName?: string;
    buttonClassName?: string;
    errorClassName?: string;
}

const CodePrompt: React.FC<CodePromptProps> = ({
    title = 'Ingresa tu código',
    placeholder = 'Código de invitación',
    buttonText = 'Continuar',
    loadingText = 'Validando...',
    emptyCodeError = 'Por favor ingresa tu código.',
    onSubmit,
    isLoading = false,
    error: submissionError = null,
    containerClassName = 'w-full max-w-md mx-auto bg-white/3 backdrop-blur-sm p-6 rounded-3xl shadow-lg',
    titleClassName = 'text-2xl text-center mb-4 text-white',
    inputClassName = 'w-full rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-gray-400 bg-black/30 text-white',
    buttonClassName = 'w-full bg-(--primary-color) text-white py-2 rounded-md hover:bg-(--hover-color) transition-colors duration-300 disabled:opacity-60',
    errorClassName = 'text-red-600 text-sm text-center'
}) => {
    const [code, setCode] = useState('');
    const [localError, setLocalError] = useState<string | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const trimmedCode = code.trim();
        if (!trimmedCode) {
            setLocalError(emptyCodeError);
            return;
        }
        // Use the sendCode function from context, which handles loading and error states.
        await onSubmit(trimmedCode);
    };

    // Display the error from the context if it exists, otherwise show local form errors.
    const displayError = submissionError || localError;

    return (
        <div className={containerClassName}>
            <h3 className={titleClassName} style={{fontWeight: 50, fontSize: '20px'}}>{title}</h3>
            <form onSubmit={handleSubmit} className="space-y-4">
                <input
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    className={inputClassName}
                    placeholder={placeholder}
                />
                {displayError && <p className={errorClassName}>{displayError}</p>}
                <button
                    type="submit"
                    disabled={isLoading}
                    className={buttonClassName}
                >
                    {isLoading ? loadingText : buttonText}
                </button>
            </form>
        </div>
    );
};

export default CodePrompt;
